import { BiContext, ConfigContextProvider, ExperimentsContext, ExternalDataProvider, ForcedStateContext, FormContext, HttpClientContext, TranslationContext, WixRicosViewerContext, AddressFormsContext, getAddressForm, EventsProvider, FieldInitialDataContext, PanoramaContext, FocusedFieldProvider, ScrollProvider } from '@wix/form-fields';
import React, { useMemo } from 'react';
import { SubmitStatusProvider } from '../../contexts/submit-status-context';
import { useFormBi } from '../form/use-form-bi';
export const FormViewerProvider = ({ i18n, bi, biFormFillSessionId, form, isMobile, isEditor, isComposer, isRTL, compId, PortalContainer, language, regionalFormat, externalData, forcedState, instance, children, httpClient, panorama, experiments, translationNamespace, currency, userData, WixRicosViewer, addressTemplates, atlasBaseUrl, fieldInitialData, enableAnimations, baseUrl })=>{
    const translations = useMemo(()=>({
            t: i18n.getFixedT(language, translationNamespace),
            i18n
        }), [
        language,
        i18n,
        translationNamespace
    ]);
    const formBi = useFormBi(form, bi, biFormFillSessionId);
    const config = useMemo(()=>({
            language,
            regionalFormat,
            instance,
            isMobile,
            currency,
            atlasBaseUrl,
            userData,
            compId,
            PortalContainer,
            baseUrl,
            isEditor,
            isComposer,
            isRTL,
            enableAnimations
        }), [
        language,
        regionalFormat,
        instance,
        isMobile,
        currency,
        atlasBaseUrl,
        userData,
        compId,
        PortalContainer,
        baseUrl,
        isEditor,
        isComposer,
        isRTL,
        enableAnimations
    ]);
    const forcedViewState = useMemo(()=>forcedState ?? [], [
        forcedState
    ]);
    return /*#__PURE__*/ React.createElement(HttpClientContext.Provider, {
        value: {
            httpClient
        }
    }, /*#__PURE__*/ React.createElement(PanoramaContext.Provider, {
        value: {
            panorama
        }
    }, /*#__PURE__*/ React.createElement(TranslationContext.Provider, {
        value: translations
    }, /*#__PURE__*/ React.createElement(ScrollProvider, null, /*#__PURE__*/ React.createElement(FocusedFieldProvider, null, /*#__PURE__*/ React.createElement(FieldInitialDataContext.Provider, {
        value: fieldInitialData
    }, /*#__PURE__*/ React.createElement(BiContext.Provider, {
        value: formBi
    }, /*#__PURE__*/ React.createElement(ExternalDataProvider, {
        externalData: externalData
    }, /*#__PURE__*/ React.createElement(ConfigContextProvider, {
        value: config
    }, /*#__PURE__*/ React.createElement(ForcedStateContext.Provider, {
        value: forcedViewState
    }, /*#__PURE__*/ React.createElement(FormContext.Provider, {
        value: form
    }, /*#__PURE__*/ React.createElement(AddressFormsContext.Provider, {
        value: {
            getCountryAddressForm: (country)=>getAddressForm(addressTemplates, country),
            addressTemplates
        }
    }, /*#__PURE__*/ React.createElement(ExperimentsContext.Provider, {
        value: experiments
    }, /*#__PURE__*/ React.createElement(EventsProvider, null, /*#__PURE__*/ React.createElement(WixRicosViewerContext.Provider, {
        value: WixRicosViewer
    }, /*#__PURE__*/ React.createElement(SubmitStatusProvider, null, children))))))))))))))));
};

//# sourceMappingURL=form-viewer-provider.js.map